import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../src/Pages/Home/Home";
import About from "./Pages/About/About";
import Blogs from "./Pages/Blogs/Blogs";
import Vacancies from "./Pages/Vacancies/Vacancies";
import ContactUs from "./Pages/ContactUs/ContactUs";
import SuccessStories from "./Pages/SuccessStories/SuccessStories";
import CandidateForm from "./Components/Home/CandidateForm";
import ReadMore from "./Components/Vacancies/ReadMore";
import EmployerForm from "./Components/Home/EmployerForm";
import CandidateApply from "./Components/Vacancies/CandidateApply";
import MainPage from "./AdminPanel/AdminPanel/MainPage";
import JobListing from "./AdminPanel/AdminPanel/JobListing";
import BlogTable from "./AdminPanel/AdminPanel/BlogTable";
import SuccessStory from "./AdminPanel/AdminPanel/SuccessStory";
import ResumeUpdate from "./AdminPanel/AdminPanel/ResumeUpdate";
import Reports from "./AdminPanel/AdminPanel/Reports";
import Login from "./AdminPanel/Login";
import PrivateRoute from "./Components/PrivateRoute";
import { ToastContainer } from 'react-toastify'; // Import ToastContainer and styles
import 'react-toastify/dist/ReactToastify.css';
// import routes from "./routes"; // Adjust the path accordingly

function App() {
  const MainComponent = () => {

    return (
      <Routes>
        <Route path="/" element={<Home/>} />
        <Route path="/About" element={<About/>} />
        <Route path="/Blogs" element={<Blogs/>} />
        <Route path="/Vacancies" element={<Vacancies/>} />
        <Route path="/SuccessStories" element={<SuccessStories/>} />
        <Route path="/ContactUs" element={<ContactUs/>} />
        <Route path="/CandidateForm" element={<CandidateForm/>} />
        <Route path="/CandidateApply" element={<CandidateApply/>} />
        <Route path="/CandidateApply/:Jobcode" element={<CandidateApply/>} />
        <Route path="/EmployerForm" element={<EmployerForm/>} />
        <Route path="/ReadMore" element={<ReadMore/>} />
        <Route path="/Login" element={<Login/>} />

        <Route element={<MainPage/>}>
             <Route path="/JobListing" element={<PrivateRoute><JobListing/></PrivateRoute>} />
             <Route path="/BlogTable" element={<PrivateRoute><BlogTable/></PrivateRoute>}/>
             <Route path="/SuccessStory" element={<PrivateRoute><SuccessStory/></PrivateRoute>}/>
             <Route path="/ResumeUpdate" element={<PrivateRoute><ResumeUpdate/></PrivateRoute>}/>
             <Route path="/Reports" element={<PrivateRoute><Reports/></PrivateRoute>}/>
         </Route>

      </Routes>
    );
  };

  return (
    <div>
    <BrowserRouter>
      <MainComponent />
     
    </BrowserRouter>
   
  <ToastContainer
  position="top-right"
  autoClose={5000}
/> </div>
  );
}

export default App;
